const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M10.8 0C4.85 0 0 4.85 0 10.8s4.85 10.8 10.8 10.8 10.8-4.85 10.8-10.8S16.75 0 10.8 0m0 2.4c4.654 0 8.4 3.747 8.4 8.4s-3.746 8.4-8.4 8.4a8.38 8.38 0 0 1-8.4-8.4c0-4.653 3.747-8.4 8.4-8.4m5.944 14.344a1.2 1.2 0 0 0 0 1.697l5.208 5.208a1.2 1.2 0 0 0 1.697 0 1.2 1.2 0 0 0 0-1.697l-5.208-5.208a1.2 1.2 0 0 0-1.697 0"
      color={color}
    ></path>
  </svg>
);

export default SvgIcon;
